import { withRouter } from "next/router";
import { useEffect, useState } from "react";
import { GET } from "../../utils/requests";
import { SubmitButton } from "../shared/input";
import OptionView from "../shared/option";
import FormSubmit from "../shared/submit";

const RentalDuration = ({ router }) => {
  const [data, setData] = useState();
  const [pId, setPId] = useState(router.query?.pId);

  useEffect(() => {
    if (router.query.rental) Fetch();
  }, [router.query]);
  const Fetch = async () =>
    setData(await GET("/cart/rental/" + router.query.rental));

  return (
    <OptionView router={router} loading={!data} property="rental">
      {!data
        ? null
        : data.map((price) => (
            <div
              className={`bg-light flex-between rounded-8 py-2 px-3 mb-3 border border-2 ${
                pId == price.id ? "border-info" : "border-white"
              }`}
              onClick={(_) => setPId(price.id)}
              role="button"
            >
              <span className="fw-bold text- font-e-lg">${price.amount}</span>
              <p className="mb-0">
                <span className="font-lg text-blue mb-0 fw-600">
                  - {price.duration.days} days{" "}
                  {price.duration.hours > 0 ? (
                    <>and {price.duration.hours} hrs</>
                  ) : null}
                </span>
                <span className="font-tiny">
                  {price.type?.replace("_", " ")}
                </span>
              </p>
            </div>
          ))}
      <FormSubmit
        url={"/cart/updaterental/" + router.query.cId}
        next="?refresh=true"
      >
        <input type="hidden" name="priceId" value={pId} />
        <SubmitButton title="Update" variant="dark mt-2" />
      </FormSubmit>
    </OptionView>
  );
};

export default withRouter(RentalDuration);
